import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id", "aria-label", "checked"];
import clsx from 'clsx';
export default /*@__PURE__*/ _defineComponent({
    __name: 'OnOffToggle',
    props: {
        id: {},
        label: { default: '' },
        modelValue: { type: Boolean, default: false },
        className: { default: undefined }
    },
    emits: ["update:modelValue", "change"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const onOffToggleStyle = {
            container: 'group relative inline-flex h-24 w-52 cursor-pointer items-center rounded-full bg-gray-500 transition-all duration-200 has-[:checked]:bg-blue-700',
            input: 'peer sr-only',
            stateText: 'text-caption-2 absolute min-w-23 text-center',
            switchButton: 'absolute top-4 left-4 h-16 w-16 rounded-full bg-white transition-all duration-200 peer-checked:translate-x-28',
        };
        const { container, input, stateText, switchButton } = onOffToggleStyle;
        const handleChange = (event) => {
            const target = event.target;
            emit('update:modelValue', target.checked);
            emit('change', target.checked);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("label", {
                class: _normalizeClass(_unref(clsx)(_unref(container), props.className))
            }, [
                _createElementVNode("input", {
                    id: props.id,
                    "aria-label": props.label,
                    checked: props.modelValue,
                    class: _normalizeClass(_unref(input)),
                    role: "switch",
                    type: "checkbox",
                    onChange: handleChange
                }, null, 42, _hoisted_1),
                _createElementVNode("span", {
                    class: _normalizeClass(_unref(clsx)(_unref(stateText), 'text-gray-250 right-6 peer-checked:hidden'))
                }, "OFF", 2),
                _createElementVNode("span", {
                    class: _normalizeClass(_unref(clsx)(_unref(stateText), 'left-6 hidden text-blue-300 peer-checked:block'))
                }, "ON", 2),
                _createElementVNode("span", {
                    class: _normalizeClass(_unref(switchButton))
                }, null, 2)
            ], 2));
        };
    }
});
